import { useContext, useEffect, useState } from 'react';
import Select from 'react-select';

import AdminModal from '../../../../reusable/admin-modal/admin-modal.component';
import Button from '../../../../reusable/button/button.component';
import Spinner from '../../../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../../../contexts/toast.context';

import Client from '../../../../../tools/client';

import {
  ButtonContainer,
  ButtonRowContainer,
  DeleteButton,
  InputContainer,
  MainContainer,
  UpdateLabel,
  UpdateInput,
} from './update-shipping-options.styles';

const client = new Client();

const UpdateShippingOption = ({ option, getOptions, reload, setShowUpdate }) => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [providers, setProviders] = useState([]);
  const [types, setTypes] = useState([]);
  const [label, setLabel] = useState(option.label);
  const [price, setPrice] = useState(option.price);
  const [freeShippingMinimum, setFreeShippingMinimum] = useState(option.freeShippingMinimum ?? '');
  const [active, setActive] = useState(option.active);

  const [providerId, setProviderId] = useState(option?.providerId ? { value: option.providerId, label: option?.ShippingProvider?.name } : null);
  const [typeId, setTypeId] = useState(option?.typeId ? { value: option.typeId, label: option?.ShippingType?.name } : null);

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    loadShippingData();
  }, []);

  const loadShippingData = async () => {
    setLoading(true);
    const [providersRes, typesRes] = await Promise.all([
      client.getShippingProviders(),
      client.getShippingTypes()
    ]);
    setProviders(providersRes);
    setTypes(typesRes);
    setLoading(false);
  };

  const updateOption = async () => {
    setLoading(true);
    const payload = {
      label,
      price: parseInt(price, 10),
      freeShippingMinimum: freeShippingMinimum ? parseInt(freeShippingMinimum, 10) : null,
      active,
      providerId: providerId?.value || null,
      typeId: typeId?.value || null
    };

    const res = await client.updateShippingOption(option.id, payload);

    if (res.status === 400 || res.error) {
      setLoading(false);
      errorToast(res.message || 'Failed to update option');
      return;
    }

    successToast('Shipping option updated');
    await getOptions();
    setLoading(false);
    setShowUpdate(false);
  };

  const deleteOption = async () => {
    setLoading(true);
    const res = await client.deleteShippingOption(option.id);

    if (res.message) {
      successToast(res.message);
      await reload();
    } else {
      errorToast('Failed to delete Shipping Option');
    }

    setLoading(false);
  };

  const statusOptions = [
    { value: true, label: 'Active' },
    { value: false, label: 'Inactive' }
  ];

  const providerOptions = providers.map(p => ({ value: p.id, label: p.name }));
  const typeOptions = types.map(t => ({ value: t.id, label: t.name }));

  return (
    <MainContainer>
      <AdminModal
        show={showModal}
        setShow={setShowModal}
        title={'Delete Shipping Option'}
        message={'Delete Shipping Option Forever?'}
        action={deleteOption}
        actionText={'DELETE'}
      />
      {loading ? (
        <Spinner />
      ) : (
        <>
          <InputContainer>
            <UpdateLabel>Label:</UpdateLabel>
            <UpdateInput value={label} onChange={(e) => setLabel(e.target.value)} />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Price (cents):</UpdateLabel>
            <UpdateInput type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Free Shipping Minimum (cents):</UpdateLabel>
            <UpdateInput
              type="number"
              value={freeShippingMinimum}
              onChange={(e) => setFreeShippingMinimum(e.target.value)}
            />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Provider:</UpdateLabel>
            <Select
              options={providerOptions}
              value={providerId}
              onChange={(option) => setProviderId(option)}
              isClearable
              placeholder="Select provider..."
            />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Type:</UpdateLabel>
            <Select
              options={typeOptions}
              value={typeId}
              onChange={(option) => setTypeId(option)}
              isClearable
              placeholder="Select type..."
            />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Status:</UpdateLabel>
            <Select
              options={statusOptions}
              value={statusOptions.find(opt => opt.value === active)}
              onChange={(selected) => setActive(selected.value)}
              isSearchable={false}
            />
          </InputContainer>

          <ButtonContainer>
            <ButtonRowContainer>
              <Button onClick={() => setShowUpdate(false)}>Cancel</Button>
              <Button onClick={updateOption}>Update</Button>
            </ButtonRowContainer>
            <ButtonRowContainer>
              <DeleteButton onClick={() => setShowModal(true)}>DELETE</DeleteButton>
            </ButtonRowContainer>
          </ButtonContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateShippingOption;